import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useUiStore } from '@/stores/ui';
import { watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheTooltip',
  setup(__props) {

const uiStore = useUiStore()

const mouseLeave = () => {
  uiStore.closeTooltip()
}

let lastEl: HTMLElement | null = null
watch(() => uiStore.tooltip.el, (item) => {
  if (lastEl) {
    lastEl.removeEventListener("mouseleave", mouseLeave)
  }
  if (item) {
    item.addEventListener("mouseleave", mouseLeave)
  }
  lastEl = item
})


return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, {
    "model-value": !!_unref(uiStore).tooltip.show,
    text: _unref(uiStore).tooltip.tooltip,
    activator: _unref(uiStore).tooltip.el || undefined,
    location: "top",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = () => {})
  }, null, 8, ["model-value", "text", "activator"]))
}
}

})